export class Result {

    public get wrong(): number {
        return this.code.length - this.ok - this.regular;
    }
    public state: string[] = [];
    constructor(
        public ok: number,
        public regular: number,
        public code: number[]
    ) {

    }

    public rotateState(i: number) {
        if (!this.state[i]) {
            this.state[i] = 'ok';
        } else if (this.state[i] == 'ok') {
            this.state[i] = 'regular';
        } else if (this.state[i] == "regular") {
            this.state[i] = 'wrong';
        } else {
            this.state[i] = null;
        }
    }


}